import { isFrame } from './isFrame';

export const getTokenKey = (salt?: boolean) => {
  const inFrame = isFrame();
  const tokenKey = inFrame ? '_support_utid' : '_utid';

  if (salt) {
    return `_s3${tokenKey}`
  }

  return tokenKey;
};
